<template>
  <b-card>
    <FormBuilder
      label="Kategori Induk"
      create
      :fields="fields"
      :loading-submit="$store.state.parentCategory.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/parent-category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('parentCategory/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
